import React from "react";
import ClientLayerBlueprint from "components/blueprints/ClientLayerBlueprint";
import ClientDashboardOverview from "./components/ClientDashboardOverview";
import ClientDashboardOrdersTable from "./components/ClientDashboardOrdersTable";
import ClientDashboardOrientation from "./components/ClientDashboardOrientation";
import ClientDashboardRecentActivity from "./components/ClientDashboardRecentActivity";
import ClientDashboardDocumentsTable from "./components/ClientDashboardDocumentsTable/ClientDashboardDocumentsTable";

function ClientDashboardPage() {
  return (
    <div className="bg-gray-100 py-2">
      <div className="container mx-auto my-6 flex">
        <section id="left" className="pr-2 w-1/2">
          <ClientDashboardOverview />
          <ClientDashboardOrdersTable />
        </section>
        <section id="right" className="pl-2 w-1/2">
          <ClientDashboardOrientation />
          <ClientDashboardRecentActivity />
          <ClientDashboardDocumentsTable />
        </section>
      </div>
    </div>
  );
}

export default ClientLayerBlueprint(ClientDashboardPage);
